import React, { useState } from "react"
import { Col, Row } from "react-bootstrap";
import { ReactComponent as ImageCaretRight } from '../../../images/caret-right-fill.svg';
import FptProgrammModal from "../../controls/FptProgrammModal";
import { Stars } from "react-bootstrap-icons";


const programmDataCurrent = {
    tag1: {
        tag: 'tag1',
        datum: '03.02.2026',
        wochentag: 'Dienstag',
        xmlFile: 'fpt037_tag1.xml',
        idFpt: 'fpt037'
    },
    tag2: {
        tag: 'tag2',
        datum: '04.02.2026',
        wochentag: 'Mittwoch',
        xmlFile: 'fpt037_tag2.xml',
        idFpt: 'fpt037'
    }
};


const ProgrammRaster2025 = (props) => {

    const [programmData, setProgrammData] = useState({
        tag: undefined,
        datum: undefined,
        wochentag: undefined,
        xmlFile: undefined,
        idFpt: undefined
    });

    const [showModal, setShowModal] = useState(false);

    //#region FormEvents

    const bttnDetailTag1Click = () => {
        setProgrammData(programmDataCurrent.tag1);
        setShowModal(true);
    }

    const bttnDetailTag2Click = () => {
        setProgrammData(programmDataCurrent.tag2);
        setShowModal(true);
    }

    //#endregion

    return (
        <React.Fragment>
            <Row className='pb-4 pb-lg-0'>
                <Col xs={12} md={6} className='pb-4'>
                    <div className="d-flex flex-column programm-wrapper" onClick={bttnDetailTag1Click}>
                        <div className="programm-white shadow-sm">
                            <strong>Dienstag</strong> {programmDataCurrent.tag1.datum}
                        </div>
                        <div className="programm-orange shadow-sm">
                            <br />
                            AI <Stars /><br />
                            Safety & Security<br />
                            Maschinenbau<br />
                            Digitalisierung<br />
                            <br />
                        </div>
                        <div className="programm-black shadow-sm">
                            Meet-the-Press Abend
                        </div>
                        <div className="programm-link">
                            <ImageCaretRight className="ProgrammDetailsButtonCaret" /> Details anzeigen
                        </div>
                    </div>
                </Col>
                <Col xs={12} md={6}>
                    <div className="d-flex flex-column programm-wrapper" onClick={bttnDetailTag2Click}>
                        <div className="programm-white shadow-sm">
                            <strong>Mittwoch</strong> {programmDataCurrent.tag2.datum}
                        </div>
                        <div className="programm-orange shadow-sm">
                            <br />
                            Prozessautomation<br />
                            Pharma<br />
                            Sensorik<br />
                            <br />
                        </div>
                        <div className="programm-link">
                            <ImageCaretRight className="ProgrammDetailsButtonCaret" /> Details anzeigen
                        </div>
                    </div>
                </Col>
            </Row>

            {showModal &&
                <FptProgrammModal onClose={() => setShowModal(false)} data={programmData} />
            }

        </React.Fragment>

    )

}
export default ProgrammRaster2025;